module.exports = __webpack_public_path__ + "static/img/cloud-lock-2.9677806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-lock-2.png
// module id = 2Nk/
// module chunks = 0